import { createSlice } from "@reduxjs/toolkit";
import { getSidebarCountData } from "./sidebarCount.action";

const sidebarCountSlice = createSlice({
  name: "sidebarCount",
  initialState: {
    countDetails: {},
  },
  extraReducers: (builder) => {
    builder.addCase(getSidebarCountData.fulfilled, (state, action) => {
      state.countDetails = { ...action.payload };
    });
  },
});

export default sidebarCountSlice.reducer;
